import React from 'react'
import { Header } from 'semantic-ui-react'

const HeaderComp = (props) => (
  <div>
    <Header color={props.color} size={props.size}>{props.info}</Header>
  </div>
)

export default HeaderComp